var map = {
	"./Page.vue": "./src/components/global/Page.vue",
	"./PageContent.vue": "./src/components/global/PageContent.vue",
	"./PageHeader.vue": "./src/components/global/PageHeader.vue",
	"./PaginationPanel.vue": "./src/components/global/PaginationPanel.vue",
	"./SearchPanel.vue": "./src/components/global/SearchPanel.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/global sync recursive \\.vue$";